module.exports = __webpack_public_path__ + "static/media/monthlyPricing.9750b6b2.svg";